import styled from 'styled-components';

const ScrollWrapper = styled.div`
  overflow-y: scroll !important;
  overflow-x: hidden;
  max-height: ${({ maxHeight }) => `${maxHeight}px`};
`;

export default ScrollWrapper;
